export default {
  data() {
    return {
      data: {},
      visible:false,
    }
  },

  methods: {
    init(id) {
      this.id = id
      this.visible = true
      if (this.id) {
        this.query()
      }
    },

    query() {
      this.$request.installment(this.id).then(resp => {
        this.data = this.$utils.conv(resp.data , { 'clearingType' : 'clearingType', 'state':'state' })
      })
    }
  },

  render(){
    const data = this.data || {}
    const title = '查看分期方案'
    return (
      <sl-side-panel v-model={this.visible} mask-closable={false} title={title}>
        <sl-detail-list label-width="110px" col={1} label-align="right" style="padding:12px;">
          <sl-detail-list-item title="名称" content={data.name} />
          <sl-detail-list-item title="金融公司" content={data.companyName} />
          <sl-detail-list-item title="每期费用">￥{data.stagesPrice}</sl-detail-list-item>
          <sl-detail-list-item title="结算方式" content={data.clearingTypeText} />
          <sl-detail-list-item title="分期数" content={data.stagesNum} />
          <sl-detail-list-item title="备注" content={data.remark} />
        </sl-detail-list>
      </sl-side-panel>
    )
  }
}
